export default {
  login: {
    login: "Sign up",
    quotation: "Welcome to VERTEX Quotation System",
    user: "User",
    password: "Password",
    logins: "Login",
    online: "online",
    offer: "Price System",
    system: "System Notification：",
  },
  routers: {
    logOut: "Log Out",
    控制台: "Dashboard",
    报价管理: "Quotation management",
    设备价格查阅: "Equipment price inquiry",
    需求填写: "Requirement form",
    表单列表: "Demand form",
    官网管理: "Official website form",
    表单数据: "Form data",
    系统管理: "System",
    个人资料: "Personal profile",
    用户列表: "User list",
    产品结构: "Product structure",
    配件结构: "Component structure",
    汇率: "Exchange rate",
    报价单记录: "Quotation records",

    SNI: "System Notification Information: ",
    SNImessages: "messages in total",
    Serial: "No.",
  },
  label: {
    snotifications: "System notifications",
    inotifications: "Inquiry notifications",
  },
  table: {
    notification: "Add Notification",
    Serial: "No.",
    Title: "Notification Title",
    content: "Notice content",
    time: "Publication Time",
    action: "Actions",
    detail: "Details",
    edit: "Edit",
    detele: "Delete",
    progress: "Inquiry Progress Information in the Last 30 Days:",
    entries: "entries in total",
    save: "Save",
    cancel: "Cancel",
  },
  offer: {
    category: "Price Category",
    sou: "Search",
    add: "Add product",
    search: "Inquire",
    close: "Close",
    view: "View",
    code: "Material Code (Alias)",
    name: "Product Model",
    photo_num: "Material Drawing Number",
    version_num: "Material Version Number",
    part_number: "Number of components",
    total_number: "Total quantity",
    weight: "Theoretical single weight (kg)",
    power: "Power (kW)",
    price: "Price Category",
    price1: "Price (USD)",
    detail: "Detailed Explanation",
    data: "No Data Available",
    Level1: "Level 1 Permission Price",
    Level2: "Level 2 Permission Price",
    Level3: "Level 3 Permission Price",
    Level4: "Level 4 Permission Price",
    Level5: "Level 5 Permission Price",
    pro: "Product modification",
    zui: "Bottom Price",
    gao: "Peak Price",
    can: "Product parameter list",
    pdf: "Product Documentation",
    zan: "No parameters currently available",
    tuji: "Photos",
    Copertina: "Cover",
    note: "Cover image only supports uploading one, recommended size: width 2480 × height 3508 px, size not exceeding 2MB",
    tip: "Note: Prices are adjusted on the first of each month based on exchange rate fluctuations.",
    document: "Product Documentation",
    ptype: "Product Type",
    poles: "Pole Number‌",
    account: "account",
    account_name: "Please enter account",
    product_name: "Product Name",
    product_model: "Product Model",
    quantity: "Quantity",
    file_name: "File Name",
    file_url: "File URL",
    export_time: "Export Time",
  },
  user: {
    username: "Username",
    nickname: "Nickname",
    Information: "Modify Information",
    resat: "Reset Password",
    User: "Add User",
    submit: "Submit",
    cancel: "Cancel",
    new: "New Password",
    old: "Old Password",
  },
  userList: {
    moble: "Phone Number",
    email: "Email",
    level: "Permission Level",
    time: "Creation Time",
    Subcategory: "Add Subcategory",
    Category: "Delete this Category",
    edit: "Edit this Category",
    add: "add",
    name: "Category name:",
    en_name: "English name:",
    it_name: "Italian name:",
    shu: "Data loading...",
    audit: "Page permissions",
  },
  official: {
    country_Code: "Country Code",
    country: "Country",
    desc: "Description",
    export: "Export",
    discount: "discount",
    rate: "exchange rate",
    title: "Please select the type of exchange rate to convert.",
    prompt:
      "Please enter a number between 0 and 100, with a maximum of 1 decimal place",
    select: "Please select a product first!",
  },
  form: {
    name: "Name",
    phone: "Number",
    email: "Email",
    contact_type: "Contact Type",
    demand_type: "Requirement Type",
    company_name: "Company Name",
    image: "Reference Picture",
    Information: "Requirement Information",
    dispose: "Dispose",
    can: "Main Parameter",
    clear: "Clear",
    time: "Time",
    chu: "Pending",
    current_url: "Website",
    li: "Processed",
    titime: "Submission Time",
    sttime: "Start Time",
    endtime: "End Time",
    rate: "Exchange Rate",
    agency: "Agency Offer",
    jsdi: "International Trade Quotation",
    currency: "RMB",
    ai: "Oops ~~ The page you are looking for is not on Earth...",
    fan: "Return to login page",
    quan: "You do not have access to the page, please contact the administrator!",
  },
  elMessage: {
    errMsg: "You have used up your export quota for today!",
  },
};
